import React from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { 
  Card, 
  CardContent, 
  Typography, 
  CardActions, 
  Button, 
  Chip, 
  Box,
  Avatar,
  AvatarGroup
} from '@mui/material';
import { 
  CalendarToday, 
  People, 
  Key, 
  PlayArrow 
} from '@mui/icons-material';
import url from '../url.js';
import { findroomByInfo } from '../utils/findRoomMode';
import '../styles/ActivityCard.css';
import ActivityInfo from '../models/ActivityInfo';

const _getActivityInfo_ = async (activityId) => {
  // ✅ 接受 activityId 參數，不從 localStorage 讀取
  const ai = await ActivityInfo.get(activityId);
  // 仍需設置 localStorage 供 Forum 組件使用
  localStorage.setItem('activityInfo', JSON.stringify(ai.toJSON()));
  return ai.toAxiosShape();
};

export default function ActivityCard({ activity }) {
  const navigate = useNavigate();
  
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(timestamp));
  };

  const getDaysRemaining = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const diffTime = end - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleEnter = async (e) => {
    e.preventDefault();
    const ag = activity && activity.ActivityGroup;
    if (!ag || !ag.Activity || !ag.Group) {
      console.warn('Invalid activity record:', activity);
      return;
    }
    const { Activity, Group } = ag;

    // 同時設置 localStorage 和 sessionStorage，確保子組件能立即讀取正確值
    localStorage.setItem('activityId', Activity.id);
    sessionStorage.setItem('activityId', Activity.id);
    localStorage.setItem('groupId', Group.groupId);
    sessionStorage.setItem('groupId', Group.groupId);
    localStorage.setItem('joinCode', Group.joinCode);
    sessionStorage.setItem('joinCode', Group.joinCode);

    // ✅ 傳入明確的 activityId
    _getActivityInfo_(Activity.id)
      .then((activityInfo) => {
        navigate(findroomByInfo(activityInfo));
      })
      .catch((error) => {
        console.error(error);
        alert("進入課程失敗，請通知管理員");
      });
  };

  const ag = activity && activity.ActivityGroup;
  if (!ag || !ag.Activity || !ag.Group) {
    return null;
  }
  const { Activity, Group } = ag;
  const memberCount = Group.userId ? Group.userId.length : 0;
  const daysRemaining = getDaysRemaining(Activity.endDate);

  return (
    <Card className="activity-card">
      <CardContent className="activity-card-content">
        {/* Header Section */}
        <Box className="activity-card-header">
          <Typography className="activity-card-title" variant="h6">
            {Activity.title}
          </Typography>
          <Chip 
            label={Group.groupName} 
            className="group-chip"
            size="small"
            variant="outlined"
          />
        </Box>

        {/* Info Section */}
        <Box className="activity-info-section">
          <Box className="info-item">
            <CalendarToday className="info-icon" />
            <Typography className="info-text">
              {formatDate(Activity.startDate)}
            </Typography>
          </Box>
          
          <Box className="info-item">
            <People className="info-icon" />
            <Typography className="info-text">
              {memberCount} 位成員
            </Typography>
          </Box>
          
          <Box className="info-item">
            <Key className="info-icon" />
            <Typography className="info-text">
              加入碼: {Group.joinCode}
            </Typography>
          </Box>
        </Box>

        {/* Status Section */}
        {/* <Box className="status-section">
          {daysRemaining > 0 ? (
            <Chip 
              label={`剩餘 ${daysRemaining} 天`} 
              className="status-chip active"
              size="small"
            />
          ) : (
            <Chip 
              label="已結束" 
              className="status-chip expired"
              size="small"
            />
          )}
        </Box> */}
      </CardContent>

      <CardActions className="activity-card-actions">
        <Button 
          className="enter-button"
          onClick={handleEnter}
          startIcon={<PlayArrow />}
          fullWidth
          variant="contained"
        >
          進入課程
        </Button>
      </CardActions>
    </Card>
  );
}